import { apiConfig } from '../api-config';

export interface GetPaymentParams {
  tokenKey: string;
  fkUser: string;
  cdAnalysis: string;
  cdTerritory: string;
  cdCompany: string;
}

export const getPayment = async (params: GetPaymentParams) => {
  const tmxToken = sessionStorage.getItem('chave');
  const headers = {
    Authorization: `${tmxToken}`,
  };

  return apiConfig
    .post('/api/Payment/get-due-data', params, { headers })
    .then((resp) => resp.data.objectResult)
    .catch((err) => ({ hasErrors: true, err }));
};
